var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeHeart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83392 0.891643C7.20417 -0.338333 9.32167 -0.2975 10.6415 1.02513C11.9614 2.34775 12.0068 4.45492 10.7792 5.82925L5.83327 10.7829L0.887471 5.82925C-0.340055 4.45492 -0.29417 2.34442 1.02513 1.02513C2.34592 -0.295662 4.45969 -0.340159 5.83392 0.891643ZM6.61325 1.75984C7.52943 0.937423 8.94128 0.972966 9.81575 1.84923C10.6861 2.7214 10.7295 4.11058 9.92839 5.0302L5.83327 9.13168L1.73829 5.0302C0.937439 4.11093 0.981067 2.7191 1.85008 1.85008C2.72712 0.973047 4.1364 0.936816 5.05522 1.76039L5.83444 2.45889L6.61325 1.75984Z",
    fill: "#25262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeHeart);
export default __webpack_public_path__ + "static/media/like-heart.1112af8e69df25316248183649477be8.svg";
export { ForwardRef as ReactComponent };